import React from "react";

export function CookieTable({ cookies, labels }) {
  if (!cookies?.length) {
    return <p className="text-sm italic text-[#3e2723]/50">{labels.no_cookies}</p>;
  }
  return (
    <div className="overflow-x-auto rounded-xl border border-[#3e2723]/10">
      <table className="w-full min-w-[640px] text-left text-sm">
        <thead className="bg-[#faf8f8] text-[11px] font-semibold uppercase tracking-wide text-[#3e2723]/55">
          <tr>
            <th className="px-4 py-3">{labels.col_name}</th>
            <th className="px-4 py-3">{labels.col_provider}</th>
            <th className="px-4 py-3">{labels.col_purpose}</th>
            <th className="px-4 py-3">{labels.col_duration}</th>
            <th className="px-4 py-3">{labels.col_type}</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#3e2723]/08 text-[#5c4039]">
          {cookies.map((row) => (
            <tr key={`${row.name}-${row.provider}`}>
              <td className="px-4 py-3 font-medium text-[#3e2723]">{row.name}</td>
              <td className="px-4 py-3">{row.provider}</td>
              <td className="px-4 py-3">{row.purpose}</td>
              <td className="px-4 py-3 whitespace-nowrap">{row.duration}</td>
              <td className="px-4 py-3 whitespace-nowrap">{row.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
